import { observer } from "mobx-react";
import { useState } from "react";
import { Layout } from "../../../styles/layout";
import CashSessionsStore from "../cash_sessions.store";
import { TextArea } from "../../../styles/form";
import { Button } from "../../../styles/button";
import CurrencyInput from "../../../components/currency-input/currency-input.view";

interface Props {
    sessionId: number;
    onClose: () => void;
}

export const CloseCashSessionModal = observer(({ sessionId, onClose }: Props) => {
    const [closingCash, setClosingCash] = useState<number>(0);
    const [note, setNote] = useState<string>("");
    const [isLoading, setIsLoading] = useState(false);

    const handleClose = async () => {
        setIsLoading(true);
        const success = await CashSessionsStore.closeCashSession(sessionId, {
            closing_cash: closingCash,
            note: note || undefined
        });
        setIsLoading(false);
        if (success) {
            onClose();
        }
    };

    return (
        <Layout vertical between={15} padding="10px" hAlign="center">
            <Layout vertical between={15} style={{ width: "100%" }}>
                <div>
                    <label>Конечная сумма в кассе</label>
                    <CurrencyInput
                        value={closingCash}
                        onChange={(value) => setClosingCash(value)}
                        min={0}
                        style={{ width: "100%" }}
                        placeholder="Введите сумму"
                    />
                </div>
                <div>
                    <label>Примечание</label>
                    <TextArea
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        placeholder="Добавьте примечание (опционально)"
                        rows={6}
                        style={{ width: "100%" }}
                    />
                </div>
            </Layout>
            <Button
                extent="L"
                onClick={handleClose}
                disabled={isLoading}
                background="#ff4d4f"
            >
                Закрыть кассу
            </Button>
        </Layout>
    );
});
